var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arion-New",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arion-Umbodshafi-04",
    transform: "translate(-968.000000, -651.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M976.879458,651.000815 C971.909552,651.067011 967.934615,655.150414 968.000815,660.121042 C968.067015,665.088706 972.150637,669.064417 977.120543,668.999209 C982.08946,668.932025 986.065385,664.848622 985.999185,659.878982 C985.932986,654.91033 981.850351,650.934619 976.879458,651.000815 L976.879458,651.000815 Z M977.877391,653.999395 C978.793316,653.999395 979.063054,654.530938 979.063054,655.13757 C979.063054,655.896354 978.455402,656.597834 977.419923,656.597834 C976.5534,656.597834 976.140394,656.161138 976.164107,655.440886 C976.165095,654.834254 976.672955,653.999395 977.877391,653.999395 L977.877391,653.999395 Z M975.531754,665.624201 C974.907304,665.624201 974.448848,665.24481 974.886555,663.576078 L975.60487,660.617018 C975.729364,660.142778 975.750113,659.953082 975.60487,659.953082 C975.417139,659.953082 974.60496,660.281098 974.125754,660.603186 L973.81353,660.091402 C975.335131,658.820834 977.082997,658.075882 977.832929,658.075882 C978.458366,658.075882 978.562112,658.815894 978.249887,659.953082 L977.428815,663.064294 C977.283571,663.613622 977.345819,663.803318 977.490074,663.803318 C977.677804,663.803318 978.292373,663.57509 978.897062,663.10085 L979.250784,663.57509 C977.771669,665.054126 976.157191,665.624201 975.531754,665.624201 L975.531754,665.624201 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.ca31269d1ed9dae4576cea53c0ad82d2.svg";
export { ForwardRef as ReactComponent };